import ImgPlaceholder from "../new_login_page/stock_img_placeholder.jpg";

export const dummySpeakerData = [
  {
    image_url: "/SPEAKER/Kim_Ramasamy.jpg",
    title: "Dr Samir Kr. Biswas Oration",
    name: "Dr Kim Ramasamy",
  },
  {
    image_url: "/SPEAKER/Mahiul_Muqit.jpg",
    title: "Dr S. K. Das Memorial Oration",
    name: "Dr Mahiul Muqit",
  },
  {
    image_url: "/SPEAKER/SS_Pandav.jpg",
    title: "Dr P. R. Mondal Memorial Oration",
    name: "Dr S S Pandav",
  },
  {
    image_url: "/SPEAKER/Santosh_Honavar.jpg",
    title: "Smt Puspa Rani Das Memorial Oration",
    name: "Dr Santosh Honavar",
  },
  {
    image_url: "/SPEAKER/Padmanabhan_Prema.jpg",
    title: "Major S. C. Dutt Oration",
    name: "Dr Padmanabhan Prema",
  },
];

export const dummyEventsData = {
  title: "Events",
  iterableDataList: [
    {
      event_name: "Live Surgeries",
      date: "Learn from the masters!",
    },
    {
      event_name: "Instruction Courses",
      date: "Masterclass in the field of Ophtalmology",
    },
    {
      event_name: "Symposiums",
      date: "Take part in learned scientific deliberations",
    },
    {
      event_name: "Paper Competition",
      date: "Discuss your research with the experts",
    },
    {
      event_name: "Video Competition",
      date: "Will you make it to the top?",
    },
    {
      event_name: "Extra-Curricular Activities",
      date: "Fun activities for all",
    },
  ],
};

export const dummyTeamData = {
  title: "Meet the Team",
  iterableDataList: [
    {
      role: "President",
      name: "Dr. Ratish Ch. Paul",
      image_url: "/TEAM/Ratish_Ch_Paul.jpg",
    },
    {
      role: "Hony Secretary",
      name: "Dr. Debasish Das",
      image_url: "/TEAM/Debasish_Das.jpg",
    },
    {
      role: "Chairman, Sc. Comm",
      name: "Dr. Rupak K Biswas",
      image_url: "/TEAM/Rupak _K_Biswas.jpg",
    },
    {
      role: "Organizing Secretary",
      name: "Dr. Sugato Paul",
      image_url: "/TEAM/Sugato_Paul.jpg",
    },
    {
      role: "Organizing Secretary",
      name: "Dr. Sudipta Mitra",
      image_url: "/TEAM/Sudipta_Mitra.jpg",
    },
    {
      role: "Organizing Secretary",
      name: "Dr. Rudra Prosad Ghosh",
      image_url: "/TEAM/Rudra_Prosad_Ghosh.jpg",
    },
    {
      role: "Organizing Secretary",
      name: "Dr. Rajesh M Chowdhury",
      image_url: "/TEAM/Rajesh_M_Chowdhury.jpg",
    },
  ],
};
